import { createContext, useContext, useState, useCallback } from "react";

const ReportIssueContext = createContext(null);

export const ReportIssueProvider = ({ children }) => {
    const [showReportModal, setShowReportModal] = useState(false);
    const [onSuccessCallback, setOnSuccessCallback] = useState(null);
    const [defaultVehicle, setDefaultVehicle] = useState(null);

    // Accepts optional onSuccess so callers can react to form submission
    const openReportModal = useCallback((onSuccess = null, options = {}) => {
        setOnSuccessCallback(() => onSuccess);
        setDefaultVehicle(options.defaultVehicle ?? null); // { value: id, name: displayName }
        setShowReportModal(true);
    }, []);

    const closeReportModal = useCallback(() => {
        setShowReportModal(false);
        setOnSuccessCallback(null);
        setDefaultVehicle(null);
    }, []);

    return (
        <ReportIssueContext.Provider value={{
            showReportModal,
            setShowReportModal,   // ← keep for backward compat, don't break other callers
            openReportModal,      // ← new: use this when you need onSuccess
            closeReportModal,
            onSuccessCallback,
            defaultVehicle
        }}>
            {children}
        </ReportIssueContext.Provider>
    );
};

export const useReportIssue = () => {
    const context = useContext(ReportIssueContext);
    return context || {
        showReportModal: false,
        setShowReportModal: () => {},
        openReportModal: () => {},
        closeReportModal: () => {},
        onSuccessCallback: null,
        defaultVehicle: null,
    };
};